import classNames from "classnames"
import { useCallback, useEffect, useMemo, useState } from "react"

/**
 * @typedef {object} ButtonsToggleProps
 * @property {any} [headerGroupItems]
 * @property {any} [initialValue]
 * @property {any} [fullDisabled]
 * @property {any} [grid]
 * @property {any} [className]
 * @property {any} [isBlocked]
 * @property {any} [tabSelected]
 */

/**
 * @param {ButtonsToggleProps} props
 */
export function ButtonsToggle({
  headerGroupItems,
  initialValue,
  fullDisabled,
  grid,
  childrenClassName,
  className,
  isBlocked,
  tabSelected,
}: $TSMigrationFixMe) {
  const [activeItem, setActiveItem] = useState(
    headerGroupItems?.[tabSelected ? tabSelected - 1 : 0]
  )
  useEffect(() => {
    if (initialValue) {
      setActiveItem(initialValue)
    }
  }, [initialValue])

  const handleActive = useCallback(
    (item: $TSMigrationFixMe) => {
      if (!isBlocked) {
        setActiveItem(item)
        item.handleClick?.(item)
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isBlocked]
  )

  const toggleLabelWithPendingValidations = (item: $TSMigrationFixMe) => (
    <div className='d-flex justify-content-center align-items-center'>
      <div className='mr-0'>{item.label}</div>
      {!!item.count && (
        <div className='documentos-pending-validations -tw-mt-3 tw-ml-1' />
      )}
    </div>
  )

  const onRenderGroupElements = useMemo(
    () =>
      headerGroupItems?.map((item: $TSMigrationFixMe) => {
        return (
          <span
            key={item.id}
            onClick={() => {
              if (!fullDisabled) {
                !item.disabled && handleActive(item)
              }
            }}
            className={classNames(`${childrenClassName} tab`, {
              activeOption: item.id === activeItem?.id,
              icon: item.children,
            })}
          >
            {item.children ? (
              <item.children />
            ) : (
              toggleLabelWithPendingValidations(item)
            )}
          </span>
        )
      }),
    [
      headerGroupItems,
      childrenClassName,
      activeItem?.id,
      fullDisabled,
      handleActive,
    ]
  )

  return (
    <div
      className={classNames([
        `button-toggle_container tw-w-full ${
          headerGroupItems?.length === 2
            ? "tw-grid tw-grid-cols-2 tw-grid-row-1"
            : "tw-grid tw-grid-cols-2 tw-grid-row-2 md:tw-grid-cols-4 md:tw-grid-row-1"
        }`,
        className,
        {
          grid,
        },
      ])}
    >
      {headerGroupItems?.length && onRenderGroupElements}
    </div>
  )
}

export default ButtonsToggle
